// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mrhy2G {
  margin-bottom: var(--spacing-3);
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
}

.nZ_914 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
  margin: 0;
}

.aWpSuY {
  display: flex;
  justify-content: center;
  width: 100%;
}

.yf8MNI {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  padding: var(--spacing-1) var(--spacing-1-5);
  transition: all 0.2s ease-in-out;
  width: 100%;
}

.UYXMmv {
  width: 16px;
  height: 16px;
  color: var(--icon-neutral-stronger);
  margin-right: var(--spacing-1);
  flex-shrink: 0;
}

._6XKdKh {
  flex: 1;
  border: none;
  background: transparent;
  font-size: var(--font-size-md);
  font-family: var(--font-family-base);
  color: var(--text-neutral-stronger);
  line-height: var(--line-height-100);
  outline: none;
  padding: 0;
}

._6XKdKh::placeholder {
  color: var(--text-neutral-medium);
}

.ZWZYJ8 {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.frnPmM {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: var(--spacing-2) 0;
  gap: var(--spacing-1);
}

.frnPmM:first-child {
  padding-top: 0;
}

.frnPmM + .frnPmM {
  border-top: 1px solid var(--stroke-neutral-subtle);
}

.yVs8Uu {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.bzw0eM {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
  display: flex;
  align-items: center;
  gap: var(--spacing-0-5);
}

.ZBYFVV {
  display: inline-flex;
  align-items: center;
  margin-left: var(--spacing-0-5);
}

.Hfh71q {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-100);
  color: var(--text-neutral-dark);
}

.Hfh71q span {
  display: inline-block;
}

.Hfh71q span + span {
  border-left: 1px solid var(--stroke-neutral-subtle);
  margin-left: var(--spacing-1);
  padding-left: var(--spacing-1);
}

.gs_NP1 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: #000000;
}

.X2jPnG {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-6);
  color: var(--text-neutral-dark);
}

.ZWZYJ8::-webkit-scrollbar {
  width: 6px;
}

.ZWZYJ8::-webkit-scrollbar-track {
  background: var(--surface-neutral-light);
  border-radius: var(--radius-xs);
}

.ZWZYJ8::-webkit-scrollbar-thumb {
  background: var(--stroke-neutral-subtle);
  border-radius: var(--radius-xs);
}

.ZWZYJ8::-webkit-scrollbar-thumb:hover {
  background: var(--text-neutral-medium);
}

@media (max-width: 768px) {
  .xiKHUQ {
    padding: var(--spacing-3);
  }

  .frnPmM {
    flex-direction: column;
    gap: var(--spacing-2);
  }

  .UmBjfO {
    align-items: flex-start;
    text-align: left;
  }

  .yf8MNI {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/RechargeDetailsModal/components/BeneficiariesList/BeneficiariesList.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,8CAA8C;EAC9C,8BAA8B;EAC9B,4CAA4C;EAC5C,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  margin-bottom: var(--spacing-3);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n}\n\n.sectionTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.searchContainer {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.searchInputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  padding: var(--spacing-1) var(--spacing-1-5);\n  transition: all 0.2s ease-in-out;\n  width: 100%;\n}\n\n.searchIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--icon-neutral-stronger);\n  margin-right: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.searchInput {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: var(--font-size-md);\n  font-family: var(--font-family-base);\n  color: var(--text-neutral-stronger);\n  line-height: var(--line-height-100);\n  outline: none;\n  padding: 0;\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-medium);\n}\n\n.beneficiariesList {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.beneficiaryItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  padding: var(--spacing-2) 0;\n  gap: var(--spacing-1);\n}\n\n.beneficiaryItem:first-child {\n  padding-top: 0;\n}\n\n.beneficiaryItem + .beneficiaryItem {\n  border-top: 1px solid var(--stroke-neutral-subtle);\n}\n\n.beneficiaryInfo {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.beneficiaryName {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0-5);\n}\n\n.detailsTooltip {\n  display: inline-flex;\n  align-items: center;\n  margin-left: var(--spacing-0-5);\n}\n\n.beneficiaryIdentifiers {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-100);\n  color: var(--text-neutral-dark);\n}\n\n.beneficiaryIdentifiers span {\n  display: inline-block;\n}\n\n.beneficiaryIdentifiers span + span {\n  border-left: 1px solid var(--stroke-neutral-subtle);\n  margin-left: var(--spacing-1);\n  padding-left: var(--spacing-1);\n}\n\n.beneficiaryValue {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: #000000;\n}\n\n.noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-6);\n  color: var(--text-neutral-dark);\n}\n\n.beneficiariesList::-webkit-scrollbar {\n  width: 6px;\n}\n\n.beneficiariesList::-webkit-scrollbar-track {\n  background: var(--surface-neutral-light);\n  border-radius: var(--radius-xs);\n}\n\n.beneficiariesList::-webkit-scrollbar-thumb {\n  background: var(--stroke-neutral-subtle);\n  border-radius: var(--radius-xs);\n}\n\n.beneficiariesList::-webkit-scrollbar-thumb:hover {\n  background: var(--text-neutral-medium);\n}\n\n@media (max-width: 768px) {\n  .beneficiariesCard {\n    padding: var(--spacing-3);\n  }\n\n  .beneficiaryItem {\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\n  .beneficiaryDetails {\n    align-items: flex-start;\n    text-align: left;\n  }\n\n  .searchInputWrapper {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Mrhy2G`,
	"sectionTitle": `nZ_914`,
	"searchContainer": `aWpSuY`,
	"searchInputWrapper": `yf8MNI`,
	"searchIcon": `UYXMmv`,
	"searchInput": `_6XKdKh`,
	"beneficiariesList": `ZWZYJ8`,
	"beneficiaryItem": `frnPmM`,
	"beneficiaryInfo": `yVs8Uu`,
	"beneficiaryName": `bzw0eM`,
	"detailsTooltip": `ZBYFVV`,
	"beneficiaryIdentifiers": `Hfh71q`,
	"beneficiaryValue": `gs_NP1`,
	"noResults": `X2jPnG`,
	"beneficiariesCard": `xiKHUQ`,
	"beneficiaryDetails": `UmBjfO`
};
module.exports = ___CSS_LOADER_EXPORT___;
